
import { Model } from 'backbone';

class ToolbarPaneModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

}

export default ToolbarPaneModel;
